import { IAppState } from '../../../AppModulesWrapper';

import { EPriceType } from '../../repositories/monolith-python/entities/offer/BargainTermsSchema';

export function selectPriceType(state: IAppState): EPriceType | null | undefined {
  const { offer } = state.servicePickerWidget;

  return offer.bargainTerms.priceType;
}
